"use client";
import CardForm, {
  CardFormBottom,
  CardFormInner,
} from "@/components/molecule/Cards/CardForm/CardForm";
import Input from "@/components/atom/Form/Input/Input";
import CheckBox from "@/components/atom/Form/Checkbox/CheckBox";
import { Link } from "@/navigation";
import Button from "@/components/atom/Form/Button/Button";
import { URL } from "@/utils/const/url";
import useRegister from "@/services/auth/useRegister";
import { useMessages, useTranslations } from "next-intl";
import { useForm } from "react-hook-form";
import { RegisterInputSchema, TRegisterInput } from "@/types/api/Auth/Register";
import { zodResolver } from "@hookform/resolvers/zod";
import useFormErrorToast from "@/hooks/useFormToast";

const RegisterForm = () => {
  const { submitRegister, loading } = useRegister();
  const messages = useMessages();
  const t = useTranslations("registerForm");

  const {
    handleSubmit,
    register,
    formState: { errors, isLoading },
  } = useForm<TRegisterInput>({
    resolver: zodResolver(RegisterInputSchema),
  });

  async function onSubmit(data: TRegisterInput) {
    await submitRegister(data);
  }

  useFormErrorToast(errors);

  return (
    <CardForm>
      <h1>{t("title")}</h1>
      <CardFormInner onSubmit={handleSubmit((data) => onSubmit(data))}>
        <div className={"card-form-inner-double"}>
          <Input
            type="text"
            label={t("name")}
            placeholder={t("name")}
            {...register("name")}
          />
          <Input
            type="text"
            label={t("surname")}
            placeholder={t("surname")}
            {...register("surname")}
          />
        </div>

        <Input
          type="text"
          label={t("email")}
          placeholder={t("email")}
          {...register("email")}
        />
        <Input
          type="password"
          label={t("password")}
          placeholder={t("password")}
          {...register("password")}
        />
        <CheckBox {...register("confirm_tos")}>
          {t("termsFirstPart")} <Link target={"_blank"} href={"/GDPR_informace-o-zpracovani-osobnich-udaju.pdf"}>{t("termsLinkPart")}</Link>
        </CheckBox>
        <CheckBox {...register("confirm_rules")}>{t("community")}</CheckBox>

        <div
          className={"mt-3"}
          style={{
            textAlign: "center",
          }}
        >
          <Button label={t("button")} isLoading={isLoading || loading} />
        </div>
      </CardFormInner>
      <CardFormBottom>
        {t("loginText")} <Link href={URL.LOGIN}>{t("loginLink")}</Link>
      </CardFormBottom>
    </CardForm>
  );
};
export default RegisterForm;
